
export class GetLead {
  static readonly type = '[Customer] Get Lead';
  constructor(public id: string) { }
}
